import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { changeToSettingMode } from '../../../js/actions/appModeActionCreators';
import { updateStatuses } from '../../../js/statuses';

const AboutPage = React.createClass({
    propTypes: {
        alignMode: PropTypes.func.isRequired,
        version: PropTypes.string
    },
    componentDidMount: function () {
        this.props.alignMode();
    },
    render: function () {
        const { version } = this.props;
        return <div>
            
            <h1>About SQL Clone</h1>
            <hr/>

            <div>
                Redgate SQL Clone &copy; 2017 Red Gate Software Ltd.
                <p>v{version}</p>
            </div>

        </div>;
    }
});

const mapStateToProps = (state) => {
    const isReady = state.users.me.updateStatus === updateStatuses.success;
    return {
        version: isReady ? state.users.me.value.value.serverVersion : null
    };
};

const mapDispatchToProps = (dispatch) => ({
    alignMode: () => {
        dispatch(changeToSettingMode());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(AboutPage);



// WEBPACK FOOTER //
// ./src/components/settings/AboutPage/index.jsx